import * as neffos from '../../neffos.min';

/**
 * Подключение к websocket. onChange вызывается (с debounce), когда запись
 * добавлена / заблокирована / удалена.
 */
export async function connectScheduleSocket(onChange, delay = 300) {
    let timer;
    const notify = () => {
        clearTimeout(timer);
        timer = setTimeout(onChange, delay);
    };

    const conn = await neffos.dial(global.wsURL, {
        default: {
            _OnNamespaceConnected: () => console.debug('connected'),
            _OnNamespaceDisconnect: () => console.debug('Disconnect'),
            onAddOccupation: notify,
            onBlockOccupation: notify,
            onDeleteOccupation: notify,
        },
    });
    conn.connect('default');

    return {
        close() {
            clearTimeout(timer);
            conn.close();
        },
    };
}
